import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Activity.css';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
import DeviceIcon from '../../components/UI/DeviceIcon/DeviceIcon';
import api from '../../axios-local-api';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import Collapsible from 'react-collapsible';
import DeviceDetails from '../DeviceList/DeviceDetails/DeviceDetails';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import SlidePanel from '../../components/UI/SlidePanel/SlidePanel';
import Success from '../../components/UI/Success/Success';
import {
  getDeviceName,
  getDeviceModel,
  getDeviceIconUrl,
  getSoftwareVersion,
  getDeviceSignalStatus,
  getDevicePauseStatus,
  getGroupMap,
  getGroupName
} from '../../shared/common';
import SelectDropdown from '../../shared/SelectDropdown/SelectDropdown';



export class Activity extends Component {
  constructor(props) {
    super(props);
    this.dayHandler = this.dayHandler.bind(this);
    this.state = {
      upstream: 0,
      downstream: 0,
      updownset: false,
      days: 7,
      upArrows: false,
      loadedAdvancedDeviceIds: false,
      newDays: true,
      // showDeviceDetails: false,
      // deviceDetails: '',
      status: '',
      showDeets: null,
      deviceIconUrl: null,
      adding: false,
      showDeets: null,
      deviceIconUrl: null,
      daysOptions: [
        { value: '1', label: 'Last 24 Hours' },
        { value: '7', label: 'Last 7 Days'},
        { value: '30', label: 'Last 30 Days'},
      ],

    };
    this.resetUpArrows = this.resetUpArrows.bind(this);
    this.updateScheduleDetails = this.updateScheduleDetails.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    // console.log(nextProps.loading, this.props.loading, 'test test')
    if (nextProps.loading !== this.props.loading) {
      // console.log('testing')
      this.setState({
        days: 7,
        newDays: true,
      });
    }
  }

  componentDidUpdate() {
    if (this.state.newDays && this.props.realBandwidth) {
      this.setState({
        daysOptions: [
          { value: '1', label: 'Last 24 Hours' },
          { value: '7', label: 'Last 7 Days'},
          { value: '30', label: 'Last 30 Days'},
        ],
        newDays: false,
      });
    }
    if (!this.state.loadedAdvancedDeviceIds) {
      //this.loadAdvancedDeviceIds();
      if (this.props.devicesByEquipment) {
        //let deviceMacs = ["a8:be:27:52:e9:26", "30:93:bc:ae:3a:40"];
        let deviceMacs = this.props.devicesByEquipment.map((d) => d.mac);
        //console.log("deviceMacs", deviceMacs);
        if (deviceMacs.length > 0) {
          this.setState({
            loadedAdvancedDeviceIds: true,
          });
          this.props.onGetAdvancedDeviceIds(deviceMacs);
        }
      }
    }

    if (this.props.devicesByEquipment && this.state.showDeets && this.state.showDeets.mac) {
      this.props.devicesByEquipment.map((d) => {
        if (d.mac === this.state.showDeets.mac) {
          if (d.freeze.frozen !== this.state.showDeets.freeze.frozen
            || d.name !== this.state.showDeets.name
            || d.freeze.timeTemplates.length !== this.state.showDeets.freeze.timeTemplates.length
            || this.state.updatedCustomSchedule && this.props.success ||
            (this.state.showDeets.steering !== d.steering)
          ) {
            this.setState({
              showDeets: d,
              updatedCustomSchedule: false
            })
            this.getAdvancedDeviceHandler(d);
          }
        }
      });
    }
  }
  openHandler() {
    this.setState({ upArrows: true });
  }
  closeHandler() {
    this.setState({ upArrows: false });
  }
  dayHandler(e) {
    // console.log('days switch', e)
    let days = e.value;
    this.setState({
      days: parseInt(days),
      newDays: true,
    });
    // this.props.onInitBandwidth(days)
  }

  getDeviceName = (device) => {

    let devices = this.props.devicesByEquipment.filter(
      (d) => d.mac === device.deviceMAC
    );
    let element = devices[0];
    var deviceName;
    if (
      !element.nickname ||
      element.nickname === undefined ||
      (element.nickname && !element.nickname.length) ||
      element.nickname === null
    ) {
      deviceName = element.name;
    } else {
      if (element.nickname.indexOf('|') !== -1) {
        deviceName = element.nickname.slice(
          element.nickname.indexOf('|') + 1,
          element.nickname.length
        );
      } else deviceName = element.nickname;
    }

    if (deviceName === undefined || deviceName.length === 0) {

      if (element.mac) {
        if (this.props.advancedDeviceIds && this.props.advancedDeviceIds[element.mac] && this.props.advancedDeviceIds[element.mac]['advancedDeviceId']) {
          if (this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['modelAccuracyLevel']
            && this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['modelAccuracyLevel'] > 4) {
            deviceName = this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['model'] ? this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['model'] : (this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['type'] ? this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['type'] : '');
          }
        }
        if ((deviceName === undefined || deviceName.length === 0) && this.props.advancedDeviceIds && this.props.advancedDeviceIds[element.mac] && this.props.advancedDeviceIds[element.mac]['advancedDeviceId']) {
          deviceName = this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['dhcpHostname'];
        }
        if (deviceName === undefined || deviceName.length === 0) {
          deviceName = element.mac;
        };
      }
      if (deviceName === undefined || deviceName.length === 0) {
        deviceName = "Unknown";
      }
    }
    return deviceName;
  };

  getDeviceIconUrl = (deviceMAC) => {
    if (!deviceMAC) {
      return undefined;
    }
   if (!this.props.devices || !this.props.devices.advancedDeviceIds) {
      return undefined;
    }
    let adid = this.props.devices.advancedDeviceIds[deviceMAC];
    if (!adid) {
      return undefined;
    }
    let icons = adid.deviceIcons.icons;
    return icons['3x'] || icons['2x'] || icons['1x'];
  };

  getReceivedTransmittedTotals = (element) => {
    let deviceReceivedTotal;
    let deviceTransmittedTotal;

    if (this.state.days === 30) {
      deviceReceivedTotal =
        element.receivedTotal >= 1024
          ? (element.receivedTotal / 1024).toFixed(2) + 'GB'
          : element.receivedTotal.toFixed(2) + 'MB';
      deviceTransmittedTotal =
        element.transmittedTotal >= 1024
          ? (element.transmittedTotal / 1024).toFixed(2) + 'GB'
          : element.transmittedTotal.toFixed(2) + 'MB';
    } else if (this.state.days === 1) {
      deviceReceivedTotal =
        element.receivedTotal24 >= 1024
          ? (element.receivedTotal24 / 1024).toFixed(2) + 'GB'
          : element.receivedTotal24.toFixed(2) + 'MB';
      deviceTransmittedTotal =
        element.transmittedTotal24 >= 1024
          ? (element.transmittedTotal24 / 1024).toFixed(2) + 'GB'
          : element.transmittedTotal24.toFixed(2) + 'MB';
    } else {
      deviceReceivedTotal =
        element.receivedTotal7 >= 1024
          ? (element.receivedTotal7 / 1024).toFixed(2) + 'GB'
          : element.receivedTotal7.toFixed(2) + 'MB';
      deviceTransmittedTotal =
        element.transmittedTotal7 >= 1024
          ? (element.transmittedTotal7 / 1024).toFixed(2) + 'GB'
          : element.transmittedTotal7.toFixed(2) + 'MB';
    }
    return {
      deviceReceivedTotal: deviceReceivedTotal,
      deviceTransmittedTotal: deviceTransmittedTotal,
    };
  };

  getUpStreamDownStreamTotals = () => {
    let totalDownstream;
    let totalUpstream;
    if (this.state.days === 30) {
      totalDownstream =
        this.props.realBandwidth && this.props.realBandwidth.downstreamTotal
          ? this.props.realBandwidth.downstreamTotal >= 1024
            ? (this.props.realBandwidth.downstreamTotal / 1024).toFixed(2) +
            'GB'
            : this.props.realBandwidth.downstreamTotal.toFixed(2) + 'MB'
          : 'N/A';
      totalUpstream =
        this.props.realBandwidth && this.props.realBandwidth.upstreamTotal
          ? this.props.realBandwidth.upstreamTotal >= 1024
            ? (this.props.realBandwidth.upstreamTotal / 1024).toFixed(2) + 'GB'
            : this.props.realBandwidth.upstreamTotal.toFixed(2) + 'MB'
          : 'N/A';
    } else if (this.state.days === 1) {
      totalDownstream =
        this.props.realBandwidth && this.props.realBandwidth.downstreamTotal24
          ? this.props.realBandwidth.downstreamTotal24 >= 1024
            ? (this.props.realBandwidth.downstreamTotal24 / 1024).toFixed(2) +
            'GB'
            : this.props.realBandwidth.downstreamTotal24.toFixed(2) + 'MB'
          : 'N/A';
      totalUpstream =
        this.props.realBandwidth && this.props.realBandwidth.upstreamTotal24
          ? this.props.realBandwidth.upstreamTotal24 >= 1024
            ? (this.props.realBandwidth.upstreamTotal24 / 1024).toFixed(2) +
            'GB'
            : this.props.realBandwidth.upstreamTotal24.toFixed(2) + 'MB'
          : 'N/A';
    } else {
      totalDownstream =
        this.props.realBandwidth && this.props.realBandwidth.downstreamTotal7
          ? this.props.realBandwidth.downstreamTotal7 >= 1024
            ? (this.props.realBandwidth.downstreamTotal7 / 1024).toFixed(2) +
            'GB'
            : this.props.realBandwidth.downstreamTotal7.toFixed(2) + 'MB'
          : 'N/A';
      totalUpstream =
        this.props.realBandwidth && this.props.realBandwidth.upstreamTotal7
          ? this.props.realBandwidth.upstreamTotal7 >= 1024
            ? (this.props.realBandwidth.upstreamTotal7 / 1024).toFixed(2) + 'GB'
            : this.props.realBandwidth.upstreamTotal7.toFixed(2) + 'MB'
          : 'N/A';
    }
    return {
      totalDownstream: totalDownstream,
      totalUpstream: totalUpstream,
    };
  };

 resetUpArrows() {
    this.setState({
      upArrows: false,
    });
  }

  updateScheduleDetails() {
    this.setState({
      updatedCustomSchedule: true
    })
  }

  modalCancelHandler = () => {
    this.setState({
      adding: false,
    });
  };

  getAdvancedDeviceHandler(element) {
    this.props.onGetAdvancedDevice(element.mac, 1);
  }

  showDeviceDetails = (element, deviceIconUrl) => {
    let device = this.props.devicesByEquipment.filter(
      (d) => d.mac === element.deviceMAC
    )[0];

    // console.log('devices:::', device);
    let status;
    if (
      device.connectionState &&
      device.connectionState === 'connected' &&
      device.freeze.frozen === true
    ) {
      status = 'Paused';
    } else if (device.health && device.health.status) {
      status =
      device.health.status.charAt(0).toUpperCase() +
      device.health.status.slice(1);
    } else {
      status = 'Disconnected';
    }
    let deviceModel = getDeviceModel(device.mac, 'fullName', this.props.advancedDeviceIds);
    let softwareVersion = getSoftwareVersion(device.mac, this.props.advancedDeviceIds);
 // console.log('getDeviceModel ::::', deviceModel  , softwareVersion);
    this.setState({
      showDeets: device,
      status: status,
      adding: true,
      deviceIconUrl: deviceIconUrl,
      deviceModel: deviceModel,
      softwareVersion: softwareVersion,
    });
    this.getAdvancedDeviceHandler(device);
  };

  render() {
    let deviceList, deviceMName, updownMstream, arrow;
    let upstreamDownstreamTotals = this.getUpStreamDownStreamTotals();
    if (this.state.upArrows) {
      arrow = (
        <MdKeyboardArrowUp aria-label="arrow up" color={'gray'} size={'30px'} />
      );
    } else {
      arrow = (
        <MdKeyboardArrowDown
          aria-label='arrow down'
          color={'gray'}
          size={'30px'}
        />
      );
    }

    let showDevIPModal;
    if (this.props.loading || !this.props.loaded) {
      deviceList = <Spinner />;
      deviceMName = <Spinner />;
      updownMstream = <Spinner />;
    } else if (!this.props.realBandwidth) {
      deviceList = (
        <div id= 'activityNoDevice' style={{ color: 'gray' }}>
          There is no Device Information available at this time
        </div>
      );
    } else if (
      this.props.realBandwidth.device &&
      this.props.realBandwidth.device.length
    ) {
      let deviceGroups = getGroupMap(this.props.deviceGroups);

      deviceMName = this.props.realBandwidth.device.map((element, ind) => {
        if (element && this.props.devicesByEquipment) {
          let devices = this.props.devicesByEquipment.filter(
            (d) => d.mac === element.deviceMAC
          );
          if (devices.length > 0) {
            let deviceName = this.getDeviceName(element);
            let deviceIconUrl = this.getDeviceIconUrl(element.deviceMAC);

            return (
              <Box key={ind}>
                <tr>
                  <td
                    style={{
                      padding: '8px',
                      display: 'flex',
                      borderLeft: 'none',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <DeviceIcon size={30} iconUrl={deviceIconUrl} />
                    <span
                      style={{
                        marginLeft: '4px',
                        width: '150px',
                        wordWrap: 'break-word',
                        whiteSpace: 'normal',
                      }}
                      className={[classes.devName, classes.RegularButton].join(
                        ' '
                      )}
                      onClick={() => {
                        // this.displayDeviceDetails(element);
                        this.showDeviceDetails(
                          element,
                          deviceIconUrl
                        )
                      }

                      }
                    >
                      {deviceName}
                    </span>
                  </td>{' '}
                </tr>
              </Box>
            );
          }
        }
      });
      updownMstream = this.props.realBandwidth.device.map((element, ind) => {
        let totals = this.getReceivedTransmittedTotals(element);
        return (
          <Box key={ind}>
            <tr>
              <td
                style={{
                  padding: '8px',
                  borderRight: 'none',
                  borderLeft: 'none',
                }}
              >
                <FaArrowUp color={'gray'} />
                {totals.deviceReceivedTotal}
              </td>
              <td
                style={{
                  padding: '8px',
                  borderRight: 'none',
                  borderLeft: 'none',
                }}
              >
                <FaArrowDown color={'gray'} />
                {totals.deviceTransmittedTotal}
              </td>{' '}
            </tr>
          </Box>
        );
      });

      deviceList = this.props.realBandwidth.device.map((element, ind, arr) => {
        if (element && this.props.devicesByEquipment) {
          let devices = this.props.devicesByEquipment.filter(
            (d) => d.mac === element.deviceMAC
          );
          if (devices.length > 0) {
            let deviceName = this.getDeviceName(element);
            let deviceIconUrl = this.getDeviceIconUrl(element.deviceMAC);
            let totals = this.getReceivedTransmittedTotals(element);

            return (
              <Box key={ind}>
                <div>
                  <div className={classes.ListItemOuter}>
                    <div className={classes.ListLeftSide}>
                      <DeviceIcon size={30} iconUrl={deviceIconUrl} />
                      <span
                        id="DeviceName"
                        style={
                          this.props.realBandwidth.fake && this.props.isDummy
                            ? {
                              color: 'pink',
                              padding: '6px 6px 6px 7px',
                              whiteSpace: 'pre',
                            }
                            : { padding: '6px 6px 6px 7px', whiteSpace: 'pre',  cursor: 'pointer'}
                        }
                        className={[classes.devName, classes.RegularButton].join(
                          ' '
                        )}
                        onClick={() => {
                          // this.displayDeviceDetails(element)
                          this.showDeviceDetails(
                            element,
                            deviceIconUrl
                          )
                        }}

                      >
                        {deviceName}
                      </span>
                    </div>

                    <div className={classes.Upright} style={{ width: '200px' }}>
                      <FaArrowUp color={'grey'} />
                      <div
                        id="Upstream"
                        style={
                          this.props.realBandwidth.fake && this.props.isDummy
                            ? { color: 'pink' }
                            : {}
                        }
                      >
                        {totals.deviceReceivedTotal}
                      </div>
                    </div>
                    <div style={{ width: '100px', textAlign: 'center' }}>
                      <FaArrowDown color={'grey'} />
                      <div
                        id="Downstream"
                        style={
                          this.props.realBandwidth.fake && this.props.isDummy
                            ? { color: 'pink' }
                            : {}
                        }
                      >
                        {totals.deviceTransmittedTotal}
                      </div>
                    </div>
                  </div>
                </div>

                <div className={classes.Separator} />
              </Box>
            );
          }
        }
      });

      if (this.state.showDeets && this.state.adding) {

        let {deviceName} = getDeviceName(this.state.showDeets, this.props.advancedDeviceIds);
        let advancedDeviceIdsType;

        let bandwidthM;
        if (
          this.props.devicesByEquipment &&
          this.props.devicesByEquipment.length &&
          this.props.bandwidth &&
          this.props.bandwidth.device
        ) {
          bandwidthM = this.props.bandwidth.device.find(
            (dev) => dev.deviceMAC === this.state.showDeets.mac
          );
        } else {
          bandwidthM = null;
        }

        if (this.props.advancedDeviceIds && this.props.advancedDeviceIds[this.state.showDeets.mac] && this.props.advancedDeviceIds[this.state.showDeets.mac]['advancedDeviceId']) {
          advancedDeviceIdsType = this.props.advancedDeviceIds[this.state.showDeets.mac]['advancedDeviceId'].type;
        }

        let originalDevice = this.state.showDeets ? this.state.showDeets : null;
        let deviceGroupName = getGroupName(deviceGroups, originalDevice.mac);
        let groupFreezeTemplate = originalDevice.freeze || false;

        if (!deviceGroupName) {
          deviceGroupName = 'Ungrouped';
        } else {
          originalDevice.freeze = groupFreezeTemplate;
        }

        let status;

        if (this.state.showDeets && this.state.showDeets.connectionState &&
          this.state.showDeets.connectionState === 'connected' &&
          this.state.showDeets.freeze.frozen === true
        ) {
          status = 'Paused';
        } else if (this.state.showDeets && this.state.showDeets.health && this.state.showDeets.health.status) {
          status =
            this.state.showDeets.health.status.charAt(0).toUpperCase() +
            this.state.showDeets.health.status.slice(1);
        } else {
          status = 'Disconnected';
        }
        showDevIPModal = (
          <div>
            <DeviceDetails
              originalDevice={originalDevice}
              devName={deviceName}
              signalStatus={status}
              bandwidth={bandwidthM}
              isLoading={this.props.loading}
              resetUpArrows={this.resetUpArrows}
              devicesByEquipment={this.props.devicesByEquipment}
              resetDevice={this.resetDeviceHandler}
              modalCancel={this.modalCancelHandler}
              deviceIconUrl={this.state.deviceIconUrl}
              deviceModel={this.state.deviceModel}
              softwareVersion={this.state.softwareVersion}
              deviceGroupName={deviceGroupName}
              groupFreezeTemplate={groupFreezeTemplate}
              updateScheduleDetails={this.updateScheduleDetails}
              advancedDeviceIdsType={advancedDeviceIdsType}
              selectedEquipment={this.props.selectedEquipment}
            />
          </div>
        );
      }
    } else {
      deviceList = (
        <div id= 'activityNoDevice' style={{ color: 'gray' }}>
          There is no Device Information available at this time
        </div>
      );
    }


    // console.log('this.state.daysOptions ::::', this.state.daysOptions);

    return (this.props.loading && !this.props.loaded) ? (
      <Box>
        <div className={[classes.showDesktop, classes.Activity].join(' ')}>
          <div className={classes.TitleArea}>
            <div className={classes.TitleLeft}>
              <h2 style={{ paddingRight: 20 }}>Activity</h2>
            </div>
          </div>
          <div className={classes.Separator} />
          <Spinner />
        </div>

        <div className={[classes.showMobile, classes.Activity].join(' ')}>
          <Collapsible
            transitionTime={100}
            onOpening={() => {
              this.openHandler();
            }}
            onClosing={() => {
              this.closeHandler();
            }}
            trigger={
              <Box>
                <div>
                  <div className={classes.TitleArea}>
                    <div className={classes.TitleLeft}>
                      <h3>Activity</h3>
                    </div>
                    <button className={classes.OpenCloseButton}>{arrow}</button>
                  </div>
                </div>
              </Box>
            }
          >
            <Spinner />
          </Collapsible>
        </div>
      </Box>
    ) : (
      <Box>
        <div className={[classes.showDesktop, classes.Activity].join(' ')}>
          <div className={classes.TitleArea}>
            <div className={classes.TitleLeft}>
              <h2 style={{ paddingRight: 20 }}>Activity</h2>
              <SelectDropdown
                height={'30px'}
                width={'150px'}
                name="activity"
                id= "activityId"
                defaultValue={this.state.daysOptions.filter(option => option.value == this.state.days)}
                options={this.state.daysOptions}
                isSearchable={false}
                onChange={(e) => {
                  this.dayHandler(e)}}
              />

            </div>
            <div className={classes.TitleRight}>
              <p style={{ paddingLeft: 20, color: '#575757' }}>
                <FaArrowUp color={'gray'} />
                Upstream
              </p>
              <p id="UpstreamTotal" style={{ color: '#0073d1' }}>
                {upstreamDownstreamTotals.totalDownstream}
              </p>
              <p style={{ paddingLeft: 20, color: '#575757' }}>
                <FaArrowDown color={'gray'} />
                Downstream
              </p>
              <p id="DownstreamTotal" style={{ color: '#0073d1' }}>
                {upstreamDownstreamTotals.totalUpstream}
              </p>
            </div>
          </div>
          <div className={classes.Separator} />

          {deviceList}
          <SlidePanel
            devDeets="true"
            show={this.state.adding}
            modalClosed={this.modalCancelHandler}
          >
            <button
              id='BackActivity'
              className={classes.RegularButton}
              style={{ marginTop: '2px' }}
              onClick={this.modalCancelHandler}
            >
              {'<'} Return to Activities
            </button>
            {showDevIPModal}
            <Modal
              show={this.state.error}
              modalClosed={this.successErrorResetHandler}
            >
              <Error id={'DeviceDetailsError'} />
            </Modal>
            <Modal
              show={this.state.success}
              modalClosed={this.successErrorResetHandler}
            >
              <Success id={'DeviceDetailsSuccess'} />
            </Modal>
          </SlidePanel>
        </div>

        <div className={[classes.showMobile, classes.Activity].join(' ')}>
          <Collapsible
            transitionTime={100}
            onOpening={() => {
              this.openHandler();
            }}
            onClosing={() => {
              this.closeHandler();
            }}
            trigger={
              <Box>
                <div>
                  <div className={classes.TitleArea}>
                    <div className={classes.TitleLeft}>
                      <h3>Activity</h3>
                    </div>
                    <button className={classes.OpenCloseButton}>{arrow}</button>
                  </div>
                </div>{' '}
              </Box>
            }
          >
            <div className={classes.Separator} />
            <div style={{ float: 'left', padding: '12px' }}>Viewing:</div>{' '}
            <div className={classes.MobileSelect} style={{
              width: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding:'9px', float:'right'
            }}>
              {this.state.daysOptions && <SelectDropdown
                height={'30px'}
                width={'150px'}
                name="activity"
                defaultValue={this.state.daysOptions.filter(option => option.value == this.state.days)}
                options={this.state.daysOptions}
                isSearchable={false}
                onChange={(e) => {
                  this.dayHandler(e)}}
              />
              }

            </div>
            <div style={{ float: 'left' }}>
              <table cellPadding="0" cellSpacing="0">
                <thead>
                  <tr>
                    <th style={{ border: '1px solid #ccc', borderLeft: '0px' }}>
                      Device
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {deviceMName}
                  <tr>
                    <td style={{ borderLeft: 'none' }}>Total</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className={classes.tablewrapper}>
              <table cellPadding="0" cellSpacing="0">
                <thead>
                  <tr>
                    <th
                      style={{
                        borderLeft: 'none',
                        border: '1px solid #ccc',
                        borderRight: '0px',
                      }}
                    >
                      Upstream
                    </th>
                    <th
                      style={{
                        borderRight: 'none',
                        border: '1px solid #ccc',
                        borderLeft: '0px',
                      }}
                    >
                      Downstream
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {updownMstream}
                  <tr>
                    <td
                      style={{
                        color: '#0073d1',
                        borderLeft: 'none',
                        borderRight: 'none',
                        paddingLeft: '15px',
                      }}
                    >
                      {' '}
                      <FaArrowUp color={'gray'} />
                      {upstreamDownstreamTotals.totalDownstream}
                    </td>
                    <td
                      style={{
                        color: '#0073d1',
                        borderLeft: 'none',
                        borderRight: 'none',
                        paddingLeft: '15px',
                      }}
                    >
                      <FaArrowDown color={'gray'} />
                      {upstreamDownstreamTotals.totalUpstream}
                    </td>{' '}
                  </tr>
                </tbody>
              </table>
            </div>
          </Collapsible>
          <SlidePanel
            devDeets="true"
            show={this.state.adding}
            modalClosed={this.modalCancelHandler}
          >
            <button
              id='BackActivity'
              className={classes.RegularButton}
              style={{ marginTop: '2px' }}
              onClick={this.modalCancelHandler}
            >
              {'<'} Return to Activities
            </button>
            {showDevIPModal}
            <Modal
              show={this.state.error}
              modalClosed={this.successErrorResetHandler}
            >
              <Error id={'DeviceDetailsError'} />
            </Modal>
            <Modal
              show={this.state.success}
              modalClosed={this.successErrorResetHandler}
            >
              <Success id={'DeviceDetailsSuccess'} />
            </Modal>
          </SlidePanel>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.bandwidth.loading,
    loaded: state.bandwidth.loaded,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    realSettings: state.settings.realSettings,
    devices: state.devices,
    isDummy: state.auth.isDummy,
    advancedDeviceIds: state.devices.advancedDeviceIds,
    deviceGroups: state.deviceGroups.deviceGroups,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInitBandwidth: (days) => dispatch(actions.initBandwidth(days)),
    onGetAdvancedDevice: (deviceMac, days) => {
      dispatch(actions.getAdvancedDevice(deviceMac, days));
    },
    onGetAdvancedDeviceIds: (deviceMacs) => {
      dispatch(actions.getAdvancedDeviceIds(deviceMacs));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Activity, api));
